var indentation_default = {
  "indentZero": "ozAti",
  "indentOne": "KvJ-d",
  "indentTwo": "_1-POR",
  "indentThree": "nB0G8",
  "indentFour": "qR5Ff",
  "indentFive": "fHoit",
  "indentSix": "DPhKc"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
